// Static UI translations for the homepage hero (heading, subtext, search placeholders, stats).
// Category chip labels and product/catalogue examples remain in English (scientific/technical terms).

const T = {
  en: {
    heading:   'AI-Powered Marketplace for Life Science Products',
    heading_highlight: 'for Life Science Products',
    subtext:   'Find lab equipment, reagents and consumables from 1,000+ verified suppliers',
    placeholders: [
      'Search by product name, Cat. No., or CAS No...',
      'Try: "Cat# TM3410L" — find by catalogue number',
      'Try: "7732-18-5" — search by CAS number',
      'Try: "I\'m looking for ELISA kits for cytokine detection"',
      'Try: "cell culture media 500ml DMEM"',
      'Try: "anti-human CD45 antibody, flow cytometry"',
      'Try: "fluorescence microscope, inverted, 40x"',
      'Try: "PCR master mix, hot-start, 100 reactions"',
    ],
    stat_buyers: 'Active Buyers',
    stat_suppliers: 'Verified Suppliers',
    stat_opportunities: 'Live Opportunities',
    stat_products: 'Products',
    search_btn:  'Search',
    try_label:   'Try:',
    post_btn:    '+ Post offer or stock',
    post_btn_brand: '+ Post offer, stock or announcement',
    all_posts:   'All posts',
    enquiries:   'ENQUIRIES',
    local_enq:   'Local enquiries',
    intl:        'International',
    offers_stock:'OFFERS & STOCK',
    local_stock: 'Local stock & offers',
    other:       'OTHER',
    brand_upd:   'Brand updates',
    filter_feed: 'FILTER FEED',
    feed_search: 'Search enquiries, products, companies...',
    feed_heading:    'Live B2B Marketplace Activity',
    feed_subtext:    'Real-time enquiries, stock updates & offers from verified users worldwide',
    products_subtext:'Browse featured & trending products. Click any category or use search above.',
    feed_filter_all: 'All Activity',
    feed_filter_enq: 'Enquiries',
    feed_filter_stk: 'Stock Updates',
    feed_filter_ann: 'Announcements',
    feed_filter_offer: 'Offers',
  },

  id: { // Bahasa Indonesia
    heading:   'Marketplace Berbasis AI untuk Produk Life Science',
    heading_highlight: 'untuk Produk Life Science',
    subtext:   'Temukan peralatan lab, reagen, dan bahan habis pakai dari 1.000+ pemasok terverifikasi',
    placeholders: [
      'Cari berdasarkan nama produk, No. Katalog, atau No. CAS...',
      'Coba: "Cat# TM3410L" — cari berdasarkan nomor katalog',
      'Coba: "7732-18-5" — cari berdasarkan nomor CAS',
      'Coba: "Saya mencari kit ELISA untuk deteksi sitokin"',
      'Coba: "media kultur sel 500ml DMEM"',
      'Coba: "antibodi anti-manusia CD45, flow cytometry"',
      'Coba: "mikroskop fluoresensi, inverted, 40x"',
      'Coba: "PCR master mix, hot-start, 100 reaksi"',
    ],
    stat_buyers: 'Pembeli Aktif',
    stat_suppliers: 'Pemasok Terverifikasi',
    stat_opportunities: 'Peluang Langsung',
    stat_products: 'Produk',
    search_btn:  'Cari',
    try_label:   'Coba:',
    post_btn:    '+ Posting penawaran atau stok',
    post_btn_brand: '+ Posting penawaran, stok atau pengumuman',
    all_posts:   'Semua postingan',
    enquiries:   'PERMINTAAN',
    local_enq:   'Permintaan lokal',
    intl:        'Internasional',
    offers_stock:'PENAWARAN & STOK',
    local_stock: 'Stok & penawaran lokal',
    other:       'LAINNYA',
    brand_upd:   'Update merek',
    filter_feed: 'FILTER FEED',
    feed_search: 'Cari permintaan, produk, perusahaan...',
    feed_heading:    'Aktivitas Pasar B2B Langsung',
    feed_subtext:    'Permintaan, pembaruan stok & penawaran real-time dari distributor terverifikasi di seluruh dunia',
    products_subtext:'Jelajahi produk unggulan & tren. Klik kategori atau gunakan pencarian di atas.',
    feed_filter_all: 'Semua Aktivitas',
    feed_filter_enq: 'Permintaan',
    feed_filter_stk: 'Pembaruan Stok',
    feed_filter_ann: 'Pengumuman',
    feed_filter_offer: 'Penawaran',
  },

  ms: { // Bahasa Melayu
    heading:   'Pasaran Berkuasa AI untuk Produk Sains Hayat',
    heading_highlight: 'untuk Produk Sains Hayat',
    subtext:   'Cari peralatan makmal, reagen dan bekalan daripada 1,000+ pembekal disahkan',
    placeholders: [
      'Cari mengikut nama produk, No. Katalog, atau No. CAS...',
      'Cuba: "Cat# TM3410L" — cari mengikut nombor katalog',
      'Cuba: "7732-18-5" — cari mengikut nombor CAS',
      'Cuba: "Saya mencari kit ELISA untuk pengesanan sitokin"',
      'Cuba: "media kultur sel 500ml DMEM"',
      'Cuba: "antibodi anti-manusia CD45, flow cytometry"',
      'Cuba: "mikroskop pendarfluor, inverted, 40x"',
      'Cuba: "PCR master mix, hot-start, 100 tindak balas"',
    ],
    stat_buyers: 'Pembeli Aktif',
    stat_suppliers: 'Pembekal Disahkan',
    stat_opportunities: 'Peluang Langsung',
    stat_products: 'Produk',
    search_btn:  'Cari',
    try_label:   'Cuba:',
    post_btn:    '+ Siar tawaran atau stok',
    post_btn_brand: '+ Siar tawaran, stok atau pengumuman',
    all_posts:   'Semua siaran',
    enquiries:   'PERTANYAAN',
    local_enq:   'Pertanyaan tempatan',
    intl:        'Antarabangsa',
    offers_stock:'TAWARAN & STOK',
    local_stock: 'Stok & tawaran tempatan',
    other:       'LAIN-LAIN',
    brand_upd:   'Kemas kini jenama',
    filter_feed: 'TAPIS SUAPAN',
    feed_search: 'Cari pertanyaan, produk, syarikat...',
    feed_heading:    'Aktiviti Pasaran B2B Langsung',
    feed_subtext:    'Pertanyaan, kemas kini stok & tawaran masa nyata dari pengedar terverifikasi di seluruh dunia',
    products_subtext:'Jelajahi produk pilihan & trending. Klik kategori atau gunakan carian di atas.',
    feed_filter_all: 'Semua Aktiviti',
    feed_filter_enq: 'Pertanyaan',
    feed_filter_stk: 'Kemas Kini Stok',
    feed_filter_ann: 'Pengumuman',
    feed_filter_offer: 'Penawaran',
  },

  ru: { // Русский
    heading:   'Маркетплейс на основе ИИ для продуктов наук о жизни',
    heading_highlight: 'для продуктов наук о жизни',
    subtext:   'Найдите лабораторное оборудование, реагенты и расходные материалы от более 1000 проверенных поставщиков',
    placeholders: [
      'Поиск по названию продукта, номеру каталога или CAS...',
      'Попробуйте: «Cat# TM3410L» — поиск по номеру каталога',
      'Попробуйте: «7732-18-5» — поиск по номеру CAS',
      'Попробуйте: «Ищу наборы ELISA для определения цитокинов»',
      'Попробуйте: «среда для клеточных культур 500 мл DMEM»',
      'Попробуйте: «антитело против человеческого CD45, флоу-цитометрия»',
      'Попробуйте: «флуоресцентный микроскоп, инвертированный, 40x»',
      'Попробуйте: «PCR master mix, hot-start, 100 реакций»',
    ],
    stat_buyers: 'Активные покупатели',
    stat_suppliers: 'Проверенные поставщики',
    stat_opportunities: 'Актуальные предложения',
    stat_products: 'Товары',
    search_btn:  'Поиск',
    try_label:   'Попробуйте:',
    post_btn:    '+ Разместить предложение или сток',
    post_btn_brand: '+ Разместить предложение, сток или объявление',
    all_posts:   'Все публикации',
    enquiries:   'ЗАПРОСЫ',
    local_enq:   'Местные запросы',
    intl:        'Международные',
    offers_stock:'ПРЕДЛОЖЕНИЯ И СТОК',
    local_stock: 'Местный сток и предложения',
    other:       'ДРУГОЕ',
    brand_upd:   'Обновления брендов',
    filter_feed: 'ФИЛЬТР ЛЕНТЫ',
    feed_search: 'Поиск запросов, продуктов, компаний...',
    feed_heading:    'Активность рынка B2B в реальном времени',
    feed_subtext:    'Запросы, обновления склада и предложения от проверенных дистрибьюторов по всему миру',
    products_subtext:'Просматривайте популярные продукты. Нажмите на категорию или воспользуйтесь поиском.',
    feed_filter_all: 'Вся активность',
    feed_filter_enq: 'Запросы',
    feed_filter_stk: 'Обновления склада',
    feed_filter_ann: 'Объявления',
    feed_filter_offer: 'Предложения',
  },

  ko: { // 한국어
    heading:   '생명과학 제품을 위한 AI 기반 마켓플레이스',
    heading_highlight: '생명과학 제품을 위한',
    subtext:   '1,000개 이상의 검증된 공급업체에서 실험 장비, 시약 및 소모품을 찾아보세요',
    placeholders: [
      '제품명, 카탈로그 번호 또는 CAS 번호로 검색...',
      '시도: "Cat# TM3410L" — 카탈로그 번호로 검색',
      '시도: "7732-18-5" — CAS 번호로 검색',
      '시도: "사이토카인 검출용 ELISA 키트를 찾고 있습니다"',
      '시도: "세포 배양 배지 500ml DMEM"',
      '시도: "항인간 CD45 항체, 유세포 분석"',
      '시도: "형광 현미경, 도립형, 40x"',
      '시도: "PCR 마스터믹스, 핫스타트, 100 반응"',
    ],
    stat_buyers: '활성 구매자',
    stat_suppliers: '검증된 공급업체',
    stat_opportunities: '실시간 기회',
    stat_products: '제품',
    search_btn:  '검색',
    try_label:   '추천:',
    post_btn:    '+ 제안 또는 재고 게시',
    post_btn_brand: '+ 제안, 재고 또는 공지 게시',
    all_posts:   '전체 게시물',
    enquiries:   '문의',
    local_enq:   '국내 문의',
    intl:        '해외',
    offers_stock:'제안 및 재고',
    local_stock: '국내 재고 및 제안',
    other:       '기타',
    brand_upd:   '브랜드 업데이트',
    filter_feed: '피드 필터',
    feed_search: '문의, 제품, 회사 검색...',
    feed_heading:    '실시간 B2B 마켓플레이스 활동',
    feed_subtext:    '전 세계 인증 유통업체의 실시간 문의, 재고 업데이트 및 오퍼',
    products_subtext:'추천 및 트렌딩 제품을 둘러보세요. 카테고리를 클릭하거나 위 검색을 사용하세요.',
    feed_filter_all: '모든 활동',
    feed_filter_enq: '문의',
    feed_filter_stk: '재고 업데이트',
    feed_filter_ann: '공지사항',
    feed_filter_offer: '오퍼',
  },

  th: { // ภาษาไทย
    heading:   'ตลาด AI สำหรับผลิตภัณฑ์ชีววิทยาศาสตร์',
    heading_highlight: 'สำหรับผลิตภัณฑ์ชีววิทยาศาสตร์',
    subtext:   'ค้นหาอุปกรณ์ห้องปฏิบัติการ รีเอเจนต์ และวัสดุสิ้นเปลืองจากผู้จัดจำหน่ายที่ผ่านการยืนยันกว่า 1,000 ราย',
    placeholders: [
      'ค้นหาด้วยชื่อผลิตภัณฑ์ หมายเลขแคตตาล็อก หรือหมายเลข CAS...',
      'ลอง: "Cat# TM3410L" — ค้นหาด้วยหมายเลขแคตตาล็อก',
      'ลอง: "7732-18-5" — ค้นหาด้วยหมายเลข CAS',
      'ลอง: "ฉันกำลังมองหาชุด ELISA สำหรับตรวจไซโตไคน์"',
      'ลอง: "อาหารเลี้ยงเซลล์ 500ml DMEM"',
      'ลอง: "แอนติบอดี anti-human CD45, flow cytometry"',
      'ลอง: "กล้องจุลทรรศน์ฟลูออเรสเซนต์ ชนิดกลับหัว 40x"',
      'ลอง: "PCR master mix, hot-start, 100 reactions"',
    ],
    stat_buyers: 'ผู้ซื้อที่ใช้งานอยู่',
    stat_suppliers: 'ผู้จัดจำหน่ายที่ผ่านการยืนยัน',
    stat_opportunities: 'โอกาสสด',
    stat_products: 'ผลิตภัณฑ์',
    search_btn:  'ค้นหา',
    try_label:   'ลองค้นหา:',
    post_btn:    '+ โพสต์ข้อเสนอหรือสต็อก',
    post_btn_brand: '+ โพสต์ข้อเสนอ สต็อก หรือประกาศ',
    all_posts:   'โพสต์ทั้งหมด',
    enquiries:   'คำขอสินค้า',
    local_enq:   'คำขอในประเทศ',
    intl:        'ต่างประเทศ',
    offers_stock:'ข้อเสนอและสต็อก',
    local_stock: 'สต็อกและข้อเสนอในประเทศ',
    other:       'อื่นๆ',
    brand_upd:   'อัปเดตแบรนด์',
    filter_feed: 'กรองฟีด',
    feed_search: 'ค้นหาคำขอ ผลิตภัณฑ์ บริษัท...',
    feed_heading:    'กิจกรรมตลาด B2B สด',
    feed_subtext:    'การสอบถาม อัพเดทสต็อก & ข้อเสนอแบบเรียลไทม์จากผู้จัดจำหน่ายที่ผ่านการยืนยันทั่วโลก',
    products_subtext:'เรียกดูผลิตภัณฑ์แนะนำและเป็นที่นิยม คลิกหมวดหมู่หรือใช้การค้นหาด้านบน',
    feed_filter_all: 'กิจกรรมทั้งหมด',
    feed_filter_enq: 'การสอบถาม',
    feed_filter_stk: 'อัพเดทสต็อก',
    feed_filter_ann: 'ประกาศ',
    feed_filter_offer: 'ข้อเสนอ',
  },

  ar: { // العربية
    heading:   'سوق مدعوم بالذكاء الاصطناعي لمنتجات علوم الحياة',
    heading_highlight: 'لمنتجات علوم الحياة',
    subtext:   'اعثر على معدات المختبرات والكواشف والمستلزمات من أكثر من 1,000 مورّد موثّق',
    placeholders: [
      'البحث باسم المنتج أو رقم الكتالوج أو رقم CAS...',
      'جرّب: "Cat# TM3410L" — البحث برقم الكتالوج',
      'جرّب: "7732-18-5" — البحث برقم CAS',
      'جرّب: "أبحث عن أطقم ELISA للكشف عن السيتوكينات"',
      'جرّب: "وسط زراعة الخلايا 500 مل DMEM"',
      'جرّب: "جسم مضاد anti-human CD45، قياس التدفق الخلوي"',
      'جرّب: "ميكروسكوب فلوري، مقلوب، 40x"',
      'جرّب: "PCR master mix، hot-start، 100 تفاعل"',
    ],
    stat_buyers: 'المشترون النشطون',
    stat_suppliers: 'الموردون الموثّقون',
    stat_opportunities: 'فرص مباشرة',
    stat_products: 'المنتجات',
    search_btn:  'بحث',
    try_label:   'جرب:',
    post_btn:    '+ نشر عرض أو مخزون',
    post_btn_brand: '+ نشر عرض أو مخزون أو إعلان',
    all_posts:   'جميع المنشورات',
    enquiries:   'الاستفسارات',
    local_enq:   'الاستفسارات المحلية',
    intl:        'دولي',
    offers_stock:'العروض والمخزون',
    local_stock: 'المخزون والعروض المحلية',
    other:       'أخرى',
    brand_upd:   'تحديثات العلامات التجارية',
    filter_feed: 'تصفية الموجز',
    feed_search: 'البحث في الاستفسارات والمنتجات والشركات...',
    feed_heading:    'نشاط السوق B2B المباشر',
    feed_subtext:    'استفسارات فورية وتحديثات المخزون والعروض من الموزعين المعتمدين حول العالم',
    products_subtext:'تصفح المنتجات المميزة والرائجة. انقر على فئة أو استخدم البحث أعلاه.',
    feed_filter_all: 'كل النشاطات',
    feed_filter_enq: 'الاستفسارات',
    feed_filter_stk: 'تحديثات المخزون',
    feed_filter_ann: 'الإعلانات',
    feed_filter_offer: 'العروض',
  },

  zh: { // 中文（简体）
    heading:   '生命科学产品AI驱动市场平台',
    heading_highlight: '生命科学产品',
    subtext:   '从1,000多家经过验证的供应商处查找实验室设备、试剂和耗材',
    placeholders: [
      '按产品名称、目录号或CAS号搜索...',
      '试试："Cat# TM3410L" — 按目录号查找',
      '试试："7732-18-5" — 按CAS号搜索',
      '试试："我在寻找用于细胞因子检测的ELISA试剂盒"',
      '试试："细胞培养基 500ml DMEM"',
      '试试："抗人CD45抗体，流式细胞术"',
      '试试："荧光显微镜，倒置式，40倍"',
      '试试："PCR master mix，热启动，100反应"',
    ],
    stat_buyers: '活跃买家',
    stat_suppliers: '已验证供应商',
    stat_opportunities: '实时机会',
    stat_products: '产品',
    search_btn:  '搜索',
    try_label:   '试试：',
    post_btn:    '+ 发布供应或库存',
    post_btn_brand: '+ 发布供应、库存或公告',
    all_posts:   '全部帖子',
    enquiries:   '询价',
    local_enq:   '本地询价',
    intl:        '国际',
    offers_stock:'供应与库存',
    local_stock: '本地库存与供应',
    other:       '其他',
    brand_upd:   '品牌动态',
    filter_feed: '筛选动态',
    feed_search: '搜索询价、产品、公司...',
    feed_heading:    '实时B2B市场动态',
    feed_subtext:    '来自全球认证经销商的实时询价、库存更新和报价',
    products_subtext:'浏览精选和热门产品。点击任意类别或使用上方搜索。',
    feed_filter_all: '全部动态',
    feed_filter_enq: '询价',
    feed_filter_stk: '库存更新',
    feed_filter_ann: '公告',
    feed_filter_offer: '优惠',
  },

  ja: { // 日本語
    heading:   'ライフサイエンス製品のAIマーケットプレイス',
    heading_highlight: 'ライフサイエンス製品の',
    subtext:   '1,000社以上の認証済みサプライヤーから実験機器、試薬、消耗品を検索',
    placeholders: [
      '製品名、カタログ番号、またはCAS番号で検索...',
      '試す: 「Cat# TM3410L」— カタログ番号で検索',
      '試す: 「7732-18-5」— CAS番号で検索',
      '試す: 「サイトカイン検出用のELISAキットを探しています」',
      '試す: 「細胞培養培地 500ml DMEM」',
      '試す: 「抗ヒトCD45抗体、フローサイトメトリー」',
      '試す: 「蛍光顕微鏡、倒立型、40倍」',
      '試す: 「PCRマスターミックス、ホットスタート、100反応」',
    ],
    stat_buyers: 'アクティブなバイヤー',
    stat_suppliers: '認証済みサプライヤー',
    stat_opportunities: 'リアルタイムの商談',
    stat_products: '製品',
    search_btn:  '検索',
    try_label:   '試してみる：',
    post_btn:    '+ 在庫・オファーを投稿',
    post_btn_brand: '+ 在庫・オファー・お知らせを投稿',
    all_posts:   'すべての投稿',
    enquiries:   '問い合わせ',
    local_enq:   '国内問い合わせ',
    intl:        '国際',
    offers_stock:'オファー＆在庫',
    local_stock: '国内在庫＆オファー',
    other:       'その他',
    brand_upd:   'ブランド更新',
    filter_feed: 'フィードフィルター',
    feed_search: '問い合わせ・製品・会社を検索...',
    feed_heading:    'リアルタイムB2Bマーケット動向',
    feed_subtext:    '世界中の認証済みディストリビューターからのリアルタイムの問い合わせ、在庫更新、オファー',
    products_subtext:'おすすめ・トレンド製品を閲覧。カテゴリをクリックまたは上部検索を使用。',
    feed_filter_all: 'すべての活動',
    feed_filter_enq: '問い合わせ',
    feed_filter_stk: '在庫更新',
    feed_filter_ann: 'お知らせ',
    feed_filter_offer: 'オファー',
  },

  de: { // Deutsch
    heading:   'KI-gestützter Marktplatz für Life-Science-Produkte',
    heading_highlight: 'für Life-Science-Produkte',
    subtext:   'Finden Sie Laborgeräte, Reagenzien und Verbrauchsmaterialien von über 1.000 verifizierten Lieferanten',
    placeholders: [
      'Suche nach Produktname, Katalognummer oder CAS-Nummer...',
      'Versuchen Sie: „Cat# TM3410L" — Suche nach Katalognummer',
      'Versuchen Sie: „7732-18-5" — Suche nach CAS-Nummer',
      'Versuchen Sie: „Ich suche ELISA-Kits für den Zytokinnachweis"',
      'Versuchen Sie: „Zellkulturmedium 500ml DMEM"',
      'Versuchen Sie: „Anti-Human-CD45-Antikörper, Durchflusszytometrie"',
      'Versuchen Sie: „Fluoreszenzmikroskop, invertiert, 40x"',
      'Versuchen Sie: „PCR-Mastermix, Hot-Start, 100 Reaktionen"',
    ],
    stat_buyers: 'Aktive Käufer',
    stat_suppliers: 'Verifizierte Lieferanten',
    stat_opportunities: 'Aktuelle Gelegenheiten',
    stat_products: 'Produkte',
    search_btn:  'Suchen',
    try_label:   'Versuche:',
    post_btn:    '+ Angebot oder Lagerbestand posten',
    post_btn_brand: '+ Angebot, Lager oder Ankündigung posten',
    all_posts:   'Alle Beiträge',
    enquiries:   'ANFRAGEN',
    local_enq:   'Lokale Anfragen',
    intl:        'International',
    offers_stock:'ANGEBOTE & LAGER',
    local_stock: 'Lokaler Lagerbestand & Angebote',
    other:       'SONSTIGES',
    brand_upd:   'Marken-Updates',
    filter_feed: 'FEED FILTERN',
    feed_search: 'Anfragen, Produkte, Unternehmen suchen...',
    feed_heading:    'Live B2B-Marktplatz-Aktivität',
    feed_subtext:    'Echtzeitanfragen, Lageraktualisierungen & Angebote von verifizierten Distributoren weltweit',
    products_subtext:'Ausgewählte & beliebte Produkte durchsuchen. Kategorie anklicken oder Suche oben verwenden.',
    feed_filter_all: 'Alle Aktivitäten',
    feed_filter_enq: 'Anfragen',
    feed_filter_stk: 'Lagerupdates',
    feed_filter_ann: 'Ankündigungen',
    feed_filter_offer: 'Angebote',
  },

  fr: { // Français
    heading:   'Marketplace IA pour les produits des sciences du vivant',
    heading_highlight: 'pour les produits des sciences du vivant',
    subtext:   'Trouvez du matériel de laboratoire, des réactifs et des consommables auprès de plus de 1 000 fournisseurs vérifiés',
    placeholders: [
      'Rechercher par nom de produit, n° de catalogue ou n° CAS...',
      'Essayez : « Cat# TM3410L » — recherche par numéro de catalogue',
      'Essayez : « 7732-18-5 » — recherche par numéro CAS',
      'Essayez : « Je recherche des kits ELISA pour la détection de cytokines »',
      'Essayez : « milieu de culture cellulaire 500 ml DMEM »',
      'Essayez : « anticorps anti-CD45 humain, cytométrie en flux »',
      'Essayez : « microscope à fluorescence, inversé, 40x »',
      'Essayez : « mélange maître PCR, hot-start, 100 réactions »',
    ],
    stat_buyers: 'Acheteurs actifs',
    stat_suppliers: 'Fournisseurs vérifiés',
    stat_opportunities: 'Opportunités en direct',
    stat_products: 'Produits',
    search_btn:  'Rechercher',
    try_label:   'Essayez :',
    post_btn:    '+ Publier une offre ou un stock',
    post_btn_brand: '+ Publier une offre, stock ou annonce',
    all_posts:   'Tous les posts',
    enquiries:   'DEMANDES',
    local_enq:   'Demandes locales',
    intl:        'International',
    offers_stock:'OFFRES & STOCK',
    local_stock: 'Stock & offres locaux',
    other:       'AUTRE',
    brand_upd:   'Actualités des marques',
    filter_feed: 'FILTRER LE FEED',
    feed_search: 'Rechercher des demandes, produits, entreprises...',
    feed_heading:    'Activité du marché B2B en direct',
    feed_subtext:    'Demandes en temps réel, mises à jour des stocks & offres de distributeurs vérifiés dans le monde',
    products_subtext:'Parcourez les produits vedettes et tendance. Cliquez sur une catégorie ou utilisez la recherche.',
    feed_filter_all: 'Toute l\'activité',
    feed_filter_enq: 'Demandes',
    feed_filter_stk: 'Mises à jour du stock',
    feed_filter_ann: 'Annonces',
    feed_filter_offer: 'Offres',
  },

  es: { // Español
    heading:   'Marketplace con IA para productos de ciencias de la vida',
    heading_highlight: 'para productos de ciencias de la vida',
    subtext:   'Encuentra equipos de laboratorio, reactivos y consumibles de más de 1000 proveedores verificados',
    placeholders: [
      'Buscar por nombre de producto, N.° de catálogo o N.° CAS...',
      'Prueba: "Cat# TM3410L" — buscar por número de catálogo',
      'Prueba: "7732-18-5" — buscar por número CAS',
      'Prueba: "Busco kits ELISA para detección de citoquinas"',
      'Prueba: "medio de cultivo celular 500ml DMEM"',
      'Prueba: "anticuerpo anti-CD45 humano, citometría de flujo"',
      'Prueba: "microscopio de fluorescencia, invertido, 40x"',
      'Prueba: "mezcla maestra PCR, hot-start, 100 reacciones"',
    ],
    stat_buyers: 'Compradores activos',
    stat_suppliers: 'Proveedores verificados',
    stat_opportunities: 'Oportunidades en vivo',
    stat_products: 'Productos',
    search_btn:  'Buscar',
    try_label:   'Prueba:',
    post_btn:    '+ Publicar oferta o stock',
    post_btn_brand: '+ Publicar oferta, stock o anuncio',
    all_posts:   'Todas las publicaciones',
    enquiries:   'CONSULTAS',
    local_enq:   'Consultas locales',
    intl:        'Internacional',
    offers_stock:'OFERTAS Y STOCK',
    local_stock: 'Stock y ofertas locales',
    other:       'OTROS',
    brand_upd:   'Actualizaciones de marcas',
    filter_feed: 'FILTRAR FEED',
    feed_search: 'Buscar consultas, productos, empresas...',
    feed_heading:    'Actividad del mercado B2B en vivo',
    feed_subtext:    'Consultas en tiempo real, actualizaciones de stock y ofertas de distribuidores verificados',
    products_subtext:'Navega productos destacados y tendencia. Haz clic en una categoría o usa la búsqueda arriba.',
    feed_filter_all: 'Toda la actividad',
    feed_filter_enq: 'Consultas',
    feed_filter_stk: 'Actualizaciones de stock',
    feed_filter_ann: 'Anuncios',
    feed_filter_offer: 'Ofertas',
  },

  pt: { // Português
    heading:   'Marketplace com IA para produtos de ciências da vida',
    heading_highlight: 'para produtos de ciências da vida',
    subtext:   'Encontre equipamentos de laboratório, reagentes e consumíveis de mais de 1.000 fornecedores verificados',
    placeholders: [
      'Pesquisar por nome do produto, N.° de catálogo ou N.° CAS...',
      'Tente: "Cat# TM3410L" — pesquisar por número de catálogo',
      'Tente: "7732-18-5" — pesquisar por número CAS',
      'Tente: "Estou procurando kits ELISA para detecção de citocinas"',
      'Tente: "meio de cultura celular 500ml DMEM"',
      'Tente: "anticorpo anti-CD45 humano, citometria de fluxo"',
      'Tente: "microscópio de fluorescência, invertido, 40x"',
      'Tente: "mix mestre de PCR, hot-start, 100 reações"',
    ],
    stat_buyers: 'Compradores ativos',
    stat_suppliers: 'Fornecedores verificados',
    stat_opportunities: 'Oportunidades em tempo real',
    stat_products: 'Produtos',
    search_btn:  'Pesquisar',
    try_label:   'Tente:',
    post_btn:    '+ Publicar oferta ou estoque',
    post_btn_brand: '+ Publicar oferta, estoque ou anúncio',
    all_posts:   'Todas as publicações',
    enquiries:   'CONSULTAS',
    local_enq:   'Consultas locais',
    intl:        'Internacional',
    offers_stock:'OFERTAS E ESTOQUE',
    local_stock: 'Estoque e ofertas locais',
    other:       'OUTROS',
    brand_upd:   'Atualizações de marcas',
    filter_feed: 'FILTRAR FEED',
    feed_search: 'Pesquisar consultas, produtos, empresas...',
    feed_heading:    'Atividade do mercado B2B ao vivo',
    feed_subtext:    'Consultas em tempo real, atualizações de estoque & ofertas de distribuidores verificados no mundo',
    products_subtext:'Navegue por produtos em destaque e tendências. Clique em uma categoria ou use a pesquisa.',
    feed_filter_all: 'Toda atividade',
    feed_filter_enq: 'Consultas',
    feed_filter_stk: 'Atualizações de estoque',
    feed_filter_ann: 'Anúncios',
    feed_filter_offer: 'Ofertas',
  },

  vi: { // Tiếng Việt
    heading:   'Sàn thương mại AI cho sản phẩm khoa học đời sống',
    heading_highlight: 'cho sản phẩm khoa học đời sống',
    subtext:   'Tìm thiết bị phòng thí nghiệm, hóa chất và vật tư tiêu hao từ hơn 1.000 nhà cung cấp đã được xác minh',
    placeholders: [
      'Tìm theo tên sản phẩm, số danh mục hoặc số CAS...',
      'Thử: "Cat# TM3410L" — tìm theo số danh mục',
      'Thử: "7732-18-5" — tìm theo số CAS',
      'Thử: "Tôi đang tìm bộ kit ELISA để phát hiện cytokine"',
      'Thử: "môi trường nuôi cấy tế bào 500ml DMEM"',
      'Thử: "kháng thể anti-human CD45, flow cytometry"',
      'Thử: "kính hiển vi huỳnh quang, đảo ngược, 40x"',
      'Thử: "PCR master mix, hot-start, 100 phản ứng"',
    ],
    stat_buyers: 'Người mua đang hoạt động',
    stat_suppliers: 'Nhà cung cấp đã xác minh',
    stat_opportunities: 'Cơ hội trực tiếp',
    stat_products: 'Sản phẩm',
    search_btn:  'Tìm kiếm',
    try_label:   'Thử:',
    post_btn:    '+ Đăng chào hàng hoặc tồn kho',
    post_btn_brand: '+ Đăng chào hàng, tồn kho hoặc thông báo',
    all_posts:   'Tất cả bài đăng',
    enquiries:   'YÊU CẦU',
    local_enq:   'Yêu cầu nội địa',
    intl:        'Quốc tế',
    offers_stock:'CHÀO HÀNG & TỒN KHO',
    local_stock: 'Tồn kho & chào hàng nội địa',
    other:       'KHÁC',
    brand_upd:   'Cập nhật thương hiệu',
    filter_feed: 'LỌC FEED',
    feed_search: 'Tìm yêu cầu, sản phẩm, công ty...',
    feed_heading:    'Hoạt động thị trường B2B trực tiếp',
    feed_subtext:    'Yêu cầu thời gian thực, cập nhật kho hàng & ưu đãi từ nhà phân phối được xác minh toàn cầu',
    products_subtext:'Duyệt sản phẩm nổi bật và xu hướng. Nhấp vào danh mục hoặc sử dụng tìm kiếm ở trên.',
    feed_filter_all: 'Tất cả hoạt động',
    feed_filter_enq: 'Yêu cầu',
    feed_filter_stk: 'Cập nhật kho hàng',
    feed_filter_ann: 'Thông báo',
    feed_filter_offer: 'Ưu đãi',
  },

  tr: { // Türkçe
    heading:   'Yaşam Bilimleri Ürünleri için YZ Destekli Pazar Yeri',
    heading_highlight: 'Yaşam Bilimleri Ürünleri için',
    subtext:   '1.000\'den fazla doğrulanmış tedarikçiden laboratuvar ekipmanı, reaktif ve sarf malzemesi bulun',
    placeholders: [
      'Ürün adı, Katalog No. veya CAS No. ile ara...',
      'Deneyin: "Cat# TM3410L" — katalog numarasına göre ara',
      'Deneyin: "7732-18-5" — CAS numarasına göre ara',
      'Deneyin: "Sitokin tespiti için ELISA kiti arıyorum"',
      'Deneyin: "hücre kültürü besiyeri 500ml DMEM"',
      'Deneyin: "anti-insan CD45 antikoru, akış sitometrisi"',
      'Deneyin: "floresan mikroskop, ters, 40x"',
      'Deneyin: "PCR master mix, hot-start, 100 reaksiyon"',
    ],
    stat_buyers: 'Aktif Alıcılar',
    stat_suppliers: 'Doğrulanmış Tedarikçiler',
    stat_opportunities: 'Canlı Fırsatlar',
    stat_products: 'Ürünler',
    search_btn:  'Ara',
    try_label:   'Deneyin:',
    post_btn:    '+ Teklif veya stok yayınla',
    post_btn_brand: '+ Teklif, stok veya duyuru yayınla',
    all_posts:   'Tüm gönderiler',
    enquiries:   'SORGULAR',
    local_enq:   'Yerel sorgular',
    intl:        'Uluslararası',
    offers_stock:'TEKLİFLER VE STOK',
    local_stock: 'Yerel stok ve teklifler',
    other:       'DİĞER',
    brand_upd:   'Marka güncellemeleri',
    filter_feed: 'FEED FİLTRE',
    feed_search: 'Sorgu, ürün, şirket ara...',
    feed_heading:    'Canlı B2B Pazar Aktivitesi',
    feed_subtext:    'Dünya genelindeki doğrulanmış distribütörlerden gerçek zamanlı sorgular, stok güncellemeleri ve teklifler',
    products_subtext:'Öne çıkan ve trend ürünleri göz atın. Bir kategoriye tıklayın veya yukarıdaki aramayı kullanın.',
    feed_filter_all: 'Tüm Aktiviteler',
    feed_filter_enq: 'Sorgular',
    feed_filter_stk: 'Stok Güncellemeleri',
    feed_filter_ann: 'Duyurular',
    feed_filter_offer: 'Teklifler',
  },
};

// Language metadata for the switcher UI
export const LANGUAGE_META = [
  { code: 'en', name: 'English',          flag: '🇬🇧' },
  { code: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ms', name: 'Bahasa Melayu',    flag: '🇲🇾' },
  { code: 'ru', name: 'Русский',          flag: '🇷🇺' },
  { code: 'ko', name: '한국어',            flag: '🇰🇷' },
  { code: 'th', name: 'ภาษาไทย',          flag: '🇹🇭' },
  { code: 'ar', name: 'العربية',          flag: '🇸🇦' },
  { code: 'zh', name: '中文',              flag: '🇨🇳' },
  { code: 'ja', name: '日本語',            flag: '🇯🇵' },
  { code: 'de', name: 'Deutsch',          flag: '🇩🇪' },
  { code: 'fr', name: 'Français',         flag: '🇫🇷' },
  { code: 'es', name: 'Español',          flag: '🇪🇸' },
  { code: 'pt', name: 'Português',        flag: '🇧🇷' },
  { code: 'vi', name: 'Tiếng Việt',       flag: '🇻🇳' },
  { code: 'tr', name: 'Türkçe',           flag: '🇹🇷' },
];

// Detect language from browser locale, respecting country-override rules.
export function detectLanguage() {
  // Manual override takes highest priority
  const saved = localStorage.getItem('biomall_lang');
  if (saved && T[saved]) return saved;

  const browserLang = (navigator.language || navigator.languages?.[0] || 'en').toLowerCase();
  const [lang, country] = browserLang.split('-');

  // Force English for India and UAE regardless of browser language
  if (country === 'in') return 'en';
  if (browserLang === 'ar-ae' || browserLang === 'en-ae') return 'en';

  // Arabic is supported for non-UAE
  if (lang === 'ar' && country !== 'ae') return 'ar';

  // Return language if we have a translation, else English
  return T[lang] ? lang : 'en';
}

export default T;
